"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetSharedTemplateUrl {
    static getAttributeTypeMap() {
        return GetSharedTemplateUrl.attributeTypeMap;
    }
}
GetSharedTemplateUrl.discriminator = undefined;
GetSharedTemplateUrl.attributeTypeMap = [
    {
        "name": "sharedUrl",
        "baseName": "sharedUrl",
        "type": "string"
    }
];
exports.GetSharedTemplateUrl = GetSharedTemplateUrl;
//# sourceMappingURL=getSharedTemplateUrl.js.map